/**
 * @title TradeIn Completed Page - How to pack items
 * @description The item that the consumer selected for tradein
 */
import * as React from "react";
import {FC} from "react";
import {Grid, GridSize, Paper} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useRecoilValue} from "recoil";
import {AppDataAtom} from "../../../providers/access/ApplicationDataProvider";

export type PackItemTradeIn = {
   items: {
      _id?: string
      name?: string
      color?: string
      size?: string
      imageUrls?: string[]
   }[]
};
type PackItemsProps = {
   tradeIn: PackItemTradeIn
}

export const PackItems: FC<PackItemsProps> = ({tradeIn}) => {
   const appData = useRecoilValue(AppDataAtom);

   const classes = useStyles();
   return <Grid item container className={classes.overflowHack}>
      {tradeIn.items.map(item => {
         let md = (12 / Math.min(3, tradeIn.items.length));
         let color = item.color && item.color !== 'N/A' && item.color !== 'NA' ? item.color : undefined;
         let size = item.size && item.size !== 'N/A' && item.size !== 'NA' ? item.size : undefined;
         return <Grid sm={md as GridSize} item xs={12} key={'packItem_' + item._id}>
            <Paper variant={"outlined"} className={classes.productItem}>
               <div className={classes.productImageContainer}>
                  <img style={{display: 'inline'}} title={'productimage'} alt='productimage'
                       className={classes.productImage} src={item.imageUrls?.[0] || appData.defaultImage}/>
               </div>
               <div className={classes.productDetailsContainer}>
                  <div className={classes.productTitleText}>{item.name}</div>
                  <div className={classes.productDetailText}>{color}</div>
                  <div className={classes.productDetailText}>{size}</div>
               </div>
            </Paper>
         </Grid>
      })}
   </Grid>;
}

const useStyles = makeStyles({
   productDetailsContainer: {
      display: 'grid',
      marginLeft: '10px'
   },
   productImage: {
      height: '60px',
      objectFit: 'cover',
      objectPosition: 'top',
      maxWidth: '40px'
   },
   productItem: {
      display: 'flex',
      marginRight: '10px',
      padding: '10px',
      backgroundColor: 'inherit'
   },
   productImageContainer: {
      display: 'block'
   },
   productTitleText: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontWeight: 600,
      overflow: 'hidden',
      minWidth: 0
   },
   productDetailText: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
   },
   overflowHack: {}
})
